import type { DataToolField } from '@ztechapps/webui.data-tools'
import { invoiceStatuses } from './InvoiceStatuses'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

export const fields: DataToolField[] = [
  { name: 'billTo.profile.name', displayName: 'Contact Name', defaultOnSearch: true },
  { name: 'billTo.company.name', displayName: 'Company Name' },
  { name: 'code', displayName: 'Code' },
  {
    name: 'createdAt',
    displayName: 'Issue date',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
  },
  {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: invoiceStatuses,
    },
  },
  { name: 'netAmount', displayName: 'Net Amount', excludeOnSearch: true },
  { name: 'grossAmount', displayName: 'Gross Amount', excludeOnSearch: true },
  { name: 'updatedAt', displayName: 'Updated At', excludeOnSearch: true, type: ListFieldTypeEnum.dateTimeZone },
  { name: 'remarks', displayName: 'Remarks' },
  { name: 'tags', displayName: 'Tags' },
  { name: '_id', excludeOnSort: true },
]
